import { render, staticRenderFns } from "./FormRecipientsPagesContainer.vue?vue&type=template&id=20f0ed04&"
import script from "./FormRecipientsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./FormRecipientsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports